import { Card } from '@bpinternal/ui-kit-next'
import {
  Zap,
  MessageSquare,
  Database,
  Code,
  FileText,
  MapPin,
  Image,
  Activity,
  Volume2,
  Tag,
  Video,
  Images,
  Layers,
  ChevronDown,
  Type,
  List,
} from 'lucide-react'
import classNames from 'classnames'
import { ComponentProps } from 'react'

type CardGridItemProps = {
  item: { name: string; type: string }
  isClickable?: boolean
} & ComponentProps<typeof Card>

export const CardGridItem = ({ item: { name, type }, isClickable, ...props }: CardGridItemProps) => {
  return (
    <>
      <Card
        {...props}
        className={classNames(
          'flex items-center rounded-lg border border-neutral-400 bg-neutral-50 p-2 px-3 text-sm text-neutral-950 shadow-none',
          { 'cursor-pointer hover:border-neutral-600': isClickable },
          props.className
        )}
      >
        <ItemIcon type={type} />
        <div className="truncate pl-1">{name}</div>
      </Card>
    </>
  )
}

type ItemIconProps = {
  type: string
}

type Icons = {
  readonly [key: string]: JSX.Element
}

export const ItemIcon = ({ type }: ItemIconProps) => {
  const icons: Icons = {
    action: <Zap className="h-4 w-4 text-primary-800" />,
    message: <MessageSquare className=" h-4 w-4 text-green-600" />,
    event: <Activity className="h-4 w-4 text-green-600" />,
    state: <Database className="h-4 w-4 text-red-600" />,
    tag: <Tag className="h-4 w-4 text-amber-600" />,
    location: <MapPin className="h-4 w-4 text-green-600" />,
    image: <Image className="h-4 w-4 text-green-600" />,
    file: <FileText className="h-4 w-4 text-green-600" />,
    video: <Video className="h-4 w-4 text-green-600" />,
    audio: <Volume2 className="h-4 w-4 text-green-600" />,
    markdown: <Code className="h-4 w-4 text-green-600" />,
    text: <Type className="h-4 w-4 text-green-600" />,
    carousel: <Images className="h-4 w-4 text-green-600" />,
    card: <Layers className="h-4 w-4 text-green-600" />,
    dropdown: <ChevronDown className="h-4 w-4 text-green-600" />,
    choice: <List className="h-4 w-4 text-green-600" />,
  }

  return icons[type] || <MessageSquare className="mr-1 h-4 w-4 text-green-600" />
}
